import React from 'react'

const Select = function ({ opts, value, rowData }) {
  const { slug, operators, etc, renderTitleHidden } = opts
  const { tableDataId = '' } = rowData

  const { payload } = operators || {}
  const { rawRowData } = payload || {}
  const others =
    (rowData && rowData[slug + '_otherSelect']) ||
    (rawRowData && rawRowData[slug + '_otherSelect']) ||
    ''
  const otherSelects =
    (rowData && rowData[slug + '_otherSelects']) ||
    (rawRowData && rawRowData[slug + '_otherSelects']) ||
    []
  const selectsArr = value.map((item) => {
    const { needInput, title, color } = item
    let text = title
    if (etc && needInput) {
      if (otherSelects) {
        const { inputValue = '' } =
          otherSelects.find((selectItem) => selectItem.slug === item.slug) || {}
        text = `${title}${inputValue ? `:${inputValue}` : ''}`
      } else {
        text = `${title}${others ? `:${others}` : ''}`
      }
    }
    return {
      text,
      color,
    }
  })

  return (
    <div
      className="flex"
      title={
        renderTitleHidden ? null : selectsArr.map((item) => item.text).join(',')
      }
    >
      {selectsArr.map((val, index) => {
        // 先写死了
        if (slug === 'specialUcaseExtStatus') {
          return (
            <div
              className="flex items-center justify-center mr-2"
              key={`${tableDataId}-${slug}-${index}`}
              style={{
                padding: '0 8px',
                minWidth: '76px',
                width: 'auto',
                height: '24px',
                background: val.color,
                borderRadius: '4px',
                fontWeight: '400',
                fontSize: '12px',
                color: '#fff',
              }}
            >
              <span>{val.text}</span>
            </div>
          )
        }
        return (
          <div
            className="flex items-center gap-2 flex-nowrap mr-2"
            key={`${tableDataId}-${slug}-${index}`}
          >
            <div
              className="rounded-full w-2 h-2"
              style={{
                background: val.color,
              }}
            />
            <span>{val.text}</span>
          </div>
        )
      })}
    </div>
  )
}

export default Select
